import { useHistory } from 'react-router';

import NoticePage from '../../../../../components/templates/NoticePage/NoticePage';
import { pagePaths } from '../../../config';
import { useCoreTranslation } from '../../../hooks/useCoreTranslation';

import { NOTICEPAGE_TYPE } from '@/components/templates/NoticePage/NoticePage.types';

const ResetPasswordFailure = () => {
  const history = useHistory();
  const { label } = useCoreTranslation(__filename);

  return (
    <NoticePage
      hideAllWidgets
      type={NOTICEPAGE_TYPE.ERROR}
      withNavBar={false}
      title={label('Password reset fail')}
      note={label('Ref: Error')}
      actions={[
        {
          label: label('Reset your password'),
          action: () => history.goBack(),
        },
        {
          label: label('Go to login page'),
          action: () => history.push(pagePaths.Home),
        },
      ]}
    />
  );
};

export default ResetPasswordFailure;
